<template>
    <div>
        <div style="background-color: #fff; padding: 5px;">
            <i>
                * Acompanhamento dos Planejamentos Semanais preenchidos pelos professores. Coordenadores
                visualizam os planos das suas instituições; equipes do Núcleo Pedagógico (SMED) visualizam toda a rede.
                Comentários enviados aqui são visíveis para o professor no Diário Eletrônico.
            </i>
        </div>

        <el-row class="u-mb-20" :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" v-if="[4, 5, 6, 7, 8].includes(Number($store.state.user.tipo))">
                <label>Instituição</label>
                <el-select v-model="filtro.instituicao_id" filterable clearable placeholder="Pesquisar Instituição" @change="changeInstituicao" style="width: 100%;">
                    <el-option v-for="item in instituicoes" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" v-if="[0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))">
                <label class="el-form-item__label">Instituição</label>
                <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12">
                <label>Curso</label>
                <el-select v-model="filtro.curso_id" filterable clearable placeholder="Pesquisar Curso" @change="changeFiltro" style="width: 100%;">
                    <el-option v-for="item in cursos" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row class="u-mt-10 u-mb-20" :gutter="10">
            <el-col :xs="24" :sm="6" :md="6">
                <label>Status</label>
                <el-select v-model="filtro.status" @change="changeFiltro" clearable placeholder="Todos">
                    <el-option v-for="(item, i) in $CONSTANTS.STATUS_PLANEJAMENTO" :key="i" :label="item" :value="i"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
                <label>Modelo</label>
                <el-select v-model="filtro.tipo_modelo" @change="changeFiltro" clearable placeholder="Todos">
                    <el-option v-for="(item, k) in $CONSTANTS.TIPO_MODELO_PLANEJAMENTO" :key="k" :label="item" :value="k"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
                <label>De (data início)</label>
                <el-date-picker
                    v-model="filtro.data_inicio"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="DD/MM/AAAA"
                    @change="changeFiltro"
                    style="width: 100%;"
                />
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
                <label>Até (data fim)</label>
                <el-date-picker
                    v-model="filtro.data_fim"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="DD/MM/AAAA"
                    @change="changeFiltro"
                    style="width: 100%;"
                />
            </el-col>
        </el-row>        

        <div class="container-table u-mt-10">
            <table v-loading="!statusList" class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 70px;">Cod.</th>
                        <th style="width: 200px;">Período</th>
                        <th>Professor</th>
                        <th>Curso / Instituição</th>
                        <th>Modelo</th>
                        <th class="u-text-center" style="width: 160px;">Status</th>
                        <th style="width: 100px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ $moment(item.data_inicio).format('DD/MM/YYYY') }} a {{ $moment(item.data_fim).format('DD/MM/YYYY') }}</td>
                        <td>
                            {{ item.user ? item.user.name : '-' }}
                            <div v-if="(item.tipo_modelo == 'eja' || item.tipo_modelo == 'anos_finais') && item.disciplina" style="font-size: 0.85em; color: #666; margin-top: 3px;">
                                <strong>Disciplina:</strong> {{ item.disciplina.temp }}
                            </div>
                        </td>
                        <td>
                            {{ item.curso ? item.curso.nome : (item.turma && item.turma.curso ? item.turma.curso.nome : '') }}
                            <div style="font-size: 0.85em; color: #888;">{{ item.instituicao ? item.instituicao.nome : '' }}</div>
                        </td>
                        <td>{{ $CONSTANTS.TIPO_MODELO_PLANEJAMENTO[item.tipo_modelo] || item.tipo_modelo }}</td>

                        <td v-if="item.status == 1" style="background-color: #FF4500; color: #ffffff;" class="u-text-center">SUBMETIDO</td>
                        <td v-else-if="item.status == 2" style="background-color: #356580; color: #ffffff;" class="u-text-center">LIDO</td>
                        <td v-else-if="item.status == 3" style="background-color: #fbff00;" class="u-text-center">COM COMENTÁRIOS</td>
                        <td v-else-if="item.status == 4" style="background-color: #5ba72c; color: #ffffff; font-weight: bold;" class="u-text-center">VALIDADO</td>
                        <td v-else class="u-text-center">{{ item.status }}</td>

                        <td class="u-text-center acao">
                            <router-link :to="`/admin/planejamento/info/${item.id}`">
                                <el-button title="Visualizar" type="primary" size="mini">
                                    <i class="fas fa-search"></i>
                                </el-button>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr v-if="statusList && items.length == 0" style="border-top: 1px solid #ddd;">
                        <td colspan="100%" class="u-text-center">
                            <span>- nenhum registro -</span>
                        </td>
                    </tr>
                    <tr v-if="paginate.qtdItens > 30">
                        <td colspan="100%" class="u-text-right">
                            <el-pagination :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data: () => ({
        statusList: false,
        filtro: {
            status: '',
            tipo_modelo: '',
            data_inicio: '',
            data_fim: '',
            instituicao_id: '',
            curso_id: ''
        },
        instituicoes: [],
        turmas: [],
        paginate: {
            page: 1,
            qtdItens: null,
        },
        items: []
    }),
    computed: {
        cursos() {
            const list = [];
            const ids = new Set();
            for (const key in this.turmas) {
                const grupo = this.turmas[key];
                if (grupo && grupo.length > 0) {
                    const first = grupo[0];
                    if (first.curso && !ids.has(first.curso.id)) {
                        ids.add(first.curso.id);
                        list.push({
                            id: first.curso.id,
                            nome: first.curso.nome
                        });
                    }
                }
            }
            return list;
        }
    },
    mounted() {
        if ([4, 5, 6, 7, 8].includes(Number(this.$store.state.user.tipo))) {
            this.getInstituicoes();
        } else {
            if (this.$store.state.config.instituicao) {
                this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            }
            this.getTurmas();
        }
        this.loadingPlanejamentos();
    },
    methods: {
        getInstituicoes() {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAllInstituicoesAtivas`, this.$store.getters.getHeaderAuth).then(response => {
                this.instituicoes = response.data;
            }).catch(error => { this.$store.commit('throwException', error); });
        },
        getTurmas() {
            let i = this.filtro.instituicao_id || (this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null);
            let p = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null;
            if (i && p) {
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {
                    this.turmas = response.data;
                }).catch(error => { this.$store.commit('throwException', error); });
            } else {
                this.turmas = [];
            }
        },
        changeInstituicao() {
            this.filtro.curso_id = '';
            this.getTurmas();
            this.changeFiltro();
        },
        changeFiltro() {
            this.paginate.page = 1;
            this.loadingPlanejamentos();
        },
        loadingPlanejamentos() {
            this.statusList = false;
            this.items = [];

            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/planejamento-pedagogico/getAllPaginate?page=` + this.paginate.page,
                this.filtro,
                this.$store.getters.getHeaderAuth
            ).then(response => {
                if (response.data && response.data.erro) {
                    this.$message({ message: response.data.erro.text || 'Erro.', type: 'warning', duration: 5000 });
                } else {
                    this.items = response.data.data || [];
                    this.paginate.qtdItens = response.data.total || 0;
                }
                this.statusList = true;
            }).catch((error) => {
                this.statusList = true;
                this.$store.commit('throwException', error);
            });
        },
        getPagePagination(page) {
            this.paginate.page = page;
            this.loadingPlanejamentos();
        }
    }
}
</script>
